import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          平台特色
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-100 rounded-lg p-5 text-center group hover:bg-primary-50/50 transition-colors"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="text-sm font-medium text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}